export function transformOptions(fetchOptions, post) {
    if (fetchOptions.headers) {
        fetchOptions.headers = new Headers(fetchOptions.headers instanceof Headers
            ? Object.fromEntries(fetchOptions.headers.entries())
            : fetchOptions.headers);
    }
    if (!fetchOptions.headers) {
        fetchOptions.headers = new Headers();
    }
    if (post) {
        return transformPostOption(fetchOptions, post);
    }
    return fetchOptions;
}
export function transformPostOption(fetchOptions, post) {
    if (fetchOptions.headers) {
        fetchOptions.headers.set('Content-Type', 'application/json');
    }
    return {
        ...fetchOptions,
        method: 'POST',
        body: JSON.stringify(post),
    };
}
export function getRetryAfterMs(headers) {
    const retryAfter = headers.get('Retry-After');
    if (!retryAfter) {
        return;
    }
    if (Number.isNaN(Number(retryAfter))) {
        return Math.max(new Date(retryAfter).getTime() - Date.now(), 0) || 0;
    }
    return Number(retryAfter) * 1000;
}
